import { useEffect, useRef, useState } from "react";
import { Post } from './Post';
import { Gtag } from './Analytics';

// SMS認証コードの「再送」と失敗文言（2026-09-03・登録/ログインの認証画面で共用）。
//
// 背景: 認証画面で失敗すると赤枠だけで理由が分からず、コードが届かない／期限切れ(5分)の
// お客様は前画面に戻ってやり直すしかなく、ここで離脱していた（RUM＋app_eventsの指摘）。
//
//   useSmsResend({ tel, isRegister, onSent })
//     → { resend, waitSec, sending }
//     resend(): /auth/send_sms.php を再呼び出し。成功時 onSent(customer_id) を呼ぶ
//               （新規登録はサーバが customers 行を新規作成するため customer_id が変わる）。
//     waitSec : 再送抑止の残り秒数（60秒）。0 なら押せる。
//
//   smsAuthErrorText(res) → 画面に出す失敗文言（API errors.js の E005/E006 に対応）
const RESEND_WAIT_SEC = 60;

export function smsAuthErrorText(res) {
  const code = res?.error_code;
  if (code === 'E005') return '認証コードが違います。届いた6桁のコードをご確認ください';
  if (code === 'E006') return '認証コードの有効期限（5分）が切れました。「認証コードを再送する」から新しいコードを取得してください';
  return res?.error_message || '認証に失敗しました。時間をおいて再度お試しください';
}

export function useSmsResend({ tel, isRegister, onSent }) {
  // 画面を開いた直後は送信直後なので、まず60秒待たせる
  const [waitSec, setWaitSec] = useState(RESEND_WAIT_SEC);
  const [sending, setSending] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (waitSec <= 0) return undefined;
    timerRef.current = setTimeout(() => setWaitSec((s) => s - 1), 1000);
    return () => clearTimeout(timerRef.current);
  }, [waitSec]);

  const resend = async () => {
    if (waitSec > 0 || sending) return null;
    setSending(true);
    const res = await Post('public', '/auth/send_sms.php', {
      key: 'yt~z7ESU6J~tLB7ppw(CLD8WddX9PNsr6DH',
      tel,
      is_register: isRegister ? 1 : 0,
    });
    setSending(false);
    if (res?.result === 1) {
      Gtag(isRegister ? 'register_resend_sms_success' : 'login_resend_sms_success');
      setWaitSec(RESEND_WAIT_SEC);
      if (onSent) onSent(res.customer_id);
    } else {
      Gtag(isRegister ? 'register_resend_sms_failed' : 'login_resend_sms_failed', { error_message: res?.error_message });
    }
    return res;
  };

  return { resend, waitSec, sending };
}

// 認証画面の下に出す「届かない場合は再送」ブロック
export const SmsResendRow = ({ waitSec, sending, onResend }) => (
  <div className="text-center mt-3" style={{ fontSize: 13 }}>
    <div className="text-gray-dark mb-1">認証コードが届かない場合</div>
    {waitSec > 0 ? (
      <span className="text-gray-dark">認証コードを再送する（{waitSec}秒後に再送できます）</span>
    ) : (
      <button type="button" className="btn btn-link p-0" style={{ fontSize: 13, textDecoration: 'underline' }} onClick={onResend} disabled={sending}>
        {sending ? '再送中…' : '認証コードを再送する'}
      </button>
    )}
  </div>
);
